import * as axios from "axios";
import { getAuthHeader } from "../utils";

export const autoSave = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}e-tour-draft/auto-save`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const getDraftList = (page: number, limit: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}e-tour-draft/list?p=${page}&l=${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const deleteDraft = (id: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}e-tour-draft/delete?id=${id}`;
  return axios.delete(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};

export const deleteDraftById = (id: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}e-draft/delete?id=${id}`;
  return axios.delete(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.message);
    }
  );
};
